module.exports = __webpack_public_path__ + "static/media/sonicleadgen.d71b61e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sonicleadgen.png
// module id = 261
// module chunks = 0